import { TournamentTypeAbstract } from "./TournamentTypeAbstract";

export class TournamentTypeFreezeout extends TournamentTypeAbstract {
}
